import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '../../../../services/data.service';

@Component({
	selector: 'members-detail-demographic-information',
	templateUrl: './demographic.html'
})
export class MembersDetailDemographicInformation {
	@Input() form: FormGroup;
	@Input() data: any;

	public constructor(
		private dataService: DataService
	) {}
}


// WEBPACK FOOTER //
// ./src/pages/members/detail/demographic/demographic.ts